module.exports = __webpack_public_path__ + "static/media/donkeykong_0.7a2699be.png";